var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M7.99992 1.33333C4.32659 1.33333 1.33325 4.32666 1.33325 8C1.33325 11.6733 4.32659 14.6667 7.99992 14.6667C11.6733 14.6667 14.6666 11.6733 14.6666 8C14.6666 4.32666 11.6733 1.33333 7.99992 1.33333ZM10.2399 9.53333C10.4333 9.72666 10.4333 10.0467 10.2399 10.24C10.1399 10.34 10.0133 10.3867 9.88659 10.3867C9.75992 10.3867 9.63325 10.34 9.53325 10.24L7.99992 8.70666L6.46659 10.24C6.36659 10.34 6.23992 10.3867 6.11325 10.3867C5.98659 10.3867 5.85992 10.34 5.75992 10.24C5.56659 10.0467 5.56659 9.72666 5.75992 9.53333L7.29325 8L5.75992 6.46666C5.56659 6.27333 5.56659 5.95333 5.75992 5.76C5.95325 5.56666 6.27325 5.56666 6.46659 5.76L7.99992 7.29333L9.53325 5.76C9.72659 5.56666 10.0466 5.56666 10.2399 5.76C10.4333 5.95333 10.4333 6.27333 10.2399 6.46666L8.70659 8L10.2399 9.53333Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }